<template>
<b-card no-body class="shadow grid-stack-item-content flex-container">
  <div slot="header">
    <window-header :cmp-title="'QA for workpack '+currentProject.workpack.id" widget-name="qa_tool">
      <template slot="left-options">
        <b-button v-b-tooltip.hover title="Run QA Job" @click="addTask" size="sm" variant="dark" type="dark" class="headerSmallButton qa-add"><icon name="plus" scale=".7"></icon></b-button>
        <b-button v-b-tooltip.hover title="Refresh QA List" @click="refreshQA" size="sm" variant="dark" type="dark" class="headerSmallButton qa-refresh"><icon name="undo" scale=".7"></icon></b-button>
        <b-button v-b-tooltip.hover id="qa-help-button" :pressed.sync="$store.getters['cmp/all']['qa_tool_info']['enabled']" title="QA Help" variant="dark" class="toolbar-button">
          <icon name="question-circle"></icon>
        </b-button>
        </template>
    </window-header>
  </div>
  <div class="window-body qa-body">
    <b-tabs pills card>
      <b-tab no-body title="Project QA" active>
        <b-container class="p-2">
          <b-row>
            <b-col md="6" class="my-1">
              <!-- <b-form-select v-model="gasDest" :options="gasDests" /> -->
              <b-form-select v-model="batch" :options="batch_zones" />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h6 class="m-0">QA last run:</h6>
            </b-col>
            <b-col>
              <h6 class="m-0">{{lastRunTime}}</h6>
            </b-col>
          </b-row>
        </b-container>
        <div>
          <tree :batch="batch" :qaData="qaData" :tableFields="qaFields" :testMap="testMap" :layerFilter="filterFeatures">
          </tree>
        </div>
      </b-tab>
      <!-- <b-tab v-if="isLogEditor" no-body title="Logistics QA">
        <logistics-qa></logistics-qa>
      </b-tab> -->
    </b-tabs>
  </div>
  <window-footer></window-footer>
</b-card>
</template>

<script>
import TasksPlugin from '../../plugin/tasks'
import Vue from 'vue'

import WindowHeader from '../common/WindowHeader'
import WindowFooter from '../common/WindowFooter'
// import LogisticsQa from '../projects/qa/LogisticsQa'
import tree from './tree.vue'

import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Style from 'ol/style/Style'
import Stroke from 'ol/style/Stroke'
import Fill from 'ol/style/Fill'
import WktFormat from 'ol/format/WKT'
import CircleStyle from 'ol/style/Circle'

export default {
  name: 'ProjectQa',
  components: {
    WindowHeader,
    WindowFooter,
    // LogisticsQa,
    tree
  },
  data() {
    return {
      tests: [],
      testMap: {},
      selectedTests: [],
      selectedDests: [],
      loading: false,
      init: false,
      selectedIssues: [],
      issueOptions: [],
      scripts: [],
      gasDests: [],
      batch_zones: [],
      batch: '',
      lastRunTime: '',
      // TODO: Default gas dest decided by config
      gasDest: 'David FCS',
      qaFields: {
        prio: {
          label: 'Prio',
          sortable: true
        },
        children: {
          label: 'Number Tests'
        },
        testname: {
          label: 'Category',
          sortable: true
        }
      }
    }
  },
  created() {
    this.qaLayer = null
    this.renderGeoms = {}

    this.layer = null
    this.layerConf = null
    this.features = []
    this.allFeatures = null
    this.qaLayerName = 'v4:_buildtestresults'
    this.overlay = null
  },
  mounted() {
    this.reload()
    this.findLayer(0)
    // Vue.use(TasksPlugin)
    // this.$tasksService.loadScripts(this)
    // if (localStorage.getItem('qa-info-unlocked') == 'true' || localStorage.getItem('qa-info-unlocked') == null) {
    //   this.infoEnabled = true
    //   this.qaInfoDest = this.batch
    // }
  },
  beforeDestroy() {
    this.$mapService.walkTree(this.$store.getters['map/layersTree'], node => {
      if (node['name'] === this.qaLayerName && node['data_type'] === 'wfs') {
        node['checked'] = false
      }
    })
  },
  destroyed() {
    this.layerConf['cql_custom'] = null
    // this.$mapService.map.removeLayer(this.layer)
    this.infoEnabled = false
    this.qaInfoData = {}
  },
  computed: {
    infoEnabled: {
      get() {
        return this.$store.getters['cmp/all']['qa_tool_info']['enabled']
      },
      set(val) {
        this.$store.getters['cmp/all']['qa_tool_info']['enabled'] = val
      }
    },
    qaInfoData: {
      get() {
        return this.$store.getters['cmp/all']['qa_tool_info']['data']
      },
      set(val) {
        this.$store.getters['cmp/all']['qa_tool_info']['data'] = val
      }
    },
    qaInfoDest: {
      get() {
        return this.$store.getters['cmp/all']['qa_tool_info']['gas_dest']
      },
      set(val) {
        this.$store.getters['cmp/all']['qa_tool_info']['gas_dest'] = val
      }
    },
    currentProject() {
      return this.$store.getters['project/currentProject']
    },
    qaData() {
      let qa = (this.currentProject.workpack.qa || [])
      let tData = []
      let workpack_wide_data = []

      let lastRunCheck = qa.find(q => q['test_id'] == 2 && q['batch_name'] == this.batch)

      if (lastRunCheck) {
        this.lastRunTime = lastRunCheck['testdatetime']
      }

      if (qa.length && !this.batch) {
        this.batch = qa[0]['batch_name']
      }
      qa.forEach(q => {
        if (!q.passed && q.optional) {
          q._rowVariant = 'warning'
        } else if (!q.passed) {
          q._rowVariant = 'danger'
        } else {
          q._rowVariant = ' '
        }
        if (q.workpack_wide && q.batch_name !== this.batch) {
          workpack_wide_data.push(q)
        }
        let c = tData.find(t => t.testname === q.test_type && t.batch_name === q.batch_name)
        if (c) {
          c['children'].push(q)

          switch (true) {
            case !c['_rowVariant'].trim():
              c['_rowVariant'] = q['_rowVariant']
              break
            case c['_rowVariant'] === 'warning' && q['_rowVariant'] === 'danger':
              c['_rowVariant'] = 'danger'
              break
          }

        } else {
          tData.push({
            testname: q['test_type'],
            _rowVariant: q['_rowVariant'],
            batch_name: q['batch_name'],
            children: [q],
            prio: q['prio'] || 20,
            _showDetails: false
          })
        }
      })

      //add workpack wide entry to all matching test types in workpack
      workpack_wide_data.forEach(q => {
        tData.forEach( c => {
          if (c.testname === q.test_type) {
            c['children'].push(q)
            switch (true) {
              case !c['_rowVariant'].trim():
                c['_rowVariant'] = q['_rowVariant']
                break
              case c['_rowVariant'] === 'warning' && q['_rowVariant'] === 'danger':
                c['_rowVariant'] = 'danger'
                break
            }
          }
        })
      })
      this.qaInfoData = tData
      return tData
    },
    qaTaskId() {
      let taskId = this.$store.getters['user/settings'].filter(s => s.usedfor === 'ui' && s.param === 'qa_task_id')
      return parseInt(taskId[0]['value'])
    },
    isLogEditor() {
      return this.$store.getters['user/user']['groups'] && this.$store.getters['user/user']['groups'].map(g => g.name).filter(name => name === 'logistics').length > 0
    }
  },
  methods: {
    refreshQA() {
      this.init = false
      this.reload()
      this.findLayer(0)
    },
    reload() {
      this.$http.get('/api/projects/qa?workpack_id=' + this.currentProject.workpack.id)
        .then(res => {
          this.currentProject.workpack.qa = res.body
          let m = {}
          res.body.forEach(r => {
            m[r['batch_name']] = true
          })
          // this.gasDests = []
          this.batch_zones = []
          let z = []
          Object.keys(m).forEach(k => {
            // this.gasDests.push(k)
            if (k != null && k != 'null') {
              z.push(k)
            }
          })

          if (z.length) {
            z.sort(function(a, b){
                if(a < b) { return -1; }
                if(a > b) { return 1; }
                return 0;
            })
            this.batch_zones = z
          }

          if (this.batch_zones.length) {
            this.batch = this.batch_zones[0]
          }
          this.$notify({
            title: 'SUCCESS',
            text: 'Reload QA List Complete',
            type: 'success'
          })
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Failed to reload QA List',
            type: 'error'
          })
        })
    },
    addTask() {
      let payload = {}

      let ids = {}

      let script = this.scripts.find(s => s.id === this.qaTaskId)

      this.$http.get('/api/projects/get-batch-id', {
        params: {
          workpack_id: this.currentProject.workpack.id,
          batch_name: this.batch
        }
      }).then(res => {
          console.log(res.body)
          if (res.body.length) {
            payload['batch'] = res.body[0]['gid']
          }
          let ids = [{
                id: this.qaTaskId,
          }]
          payload['ids'] = ids
          payload['project_id'] = this.currentProject.id
          payload['workpack_id'] = this.currentProject.workpack.id
          payload['batch_name'] = this.batch

          console.log(payload)
          this.$tasksService.addTasks(this, payload)

        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Failed to load batch id',
            type: 'error'
        })
      })


    },
    changeQaGeoms(vals) {
      vals.forEach(val => {
        if (val.geo == null) {
          this.renderGeoms[val.testname] = null
        } else {
          this.renderGeoms[val.testname] = val.geo
        }
      })
      this.refreshRenderGeoms()
    },
    refreshRenderGeoms() {
      let val = this.renderGeoms
      let geoms = []
      let wktFormat = new WktFormat()

      if (this.qaLayer) {
        this.$mapService.map.removeLayer(this.qaLayer)
      }
      for (let k in val) {
        if (val.hasOwnProperty(k) && val[k]) {
          geoms.push(wktFormat.readFeatureFromText(val[k]))
        }
      }
      this.qaLayer = new VectorLayer({
        source: new VectorSource({
          features: geoms
        }),
        style: () => {
          let fill = new Fill({
            color: '#ff0000'
          })
          let stroke = new Stroke({
            color: "#ff0000",
            width: 3
          })

          return [
            new Style({
              fill: fill,
              stroke: stroke,
              image: new CircleStyle({
                fill: fill,
                stroke: stroke,
                radius: 3
              })
            })
          ]
        }
      })

      this.$mapService.map.addLayer(this.qaLayer)
      if (geoms.length) {
        this.$mapService.map.getView().fit(this.qaLayer.getSource().getExtent())
        this.$mapService.map.getView().setZoom(13)
      }
    },
    findLayer(lev) {
      if (lev > 50) {
        this.$notify({
          title: 'ERROR',
          text: 'Could not load qa layer',
          type: 'error'
        })
        return
      }
      this.loading = true
      let n = null
      let layer = null
      if (!this.layerConf) {
        this.$mapService.walkTree(this.$store.getters['map/layersTree'], node => {
          if (node['name'] === this.qaLayerName && node['data_type'] === 'wfs') {
            n = node
          }
        })
      } else {
        n = this.layerConf
      }
      if (n) {
        layer = this.$mapService._layerExists(n)
        if (!layer || n['loading']) {
          if (lev === 0) {
            this.$mapService.forceCreateLayer(n)
          }
          setTimeout(() => {
            this.findLayer(++lev)
          }, 500)
        } else {
          this.layer = layer
          this.$mapService.setLayerLabel(n, ['short_label'])
          this.loading = false
          this.layerConf = n
          this.collectLabels()
        }
      } else {
        this.$notify({
          title: 'ERROR',
          text: 'Could not find qa layer. Please add it to the project',
          type: 'error'
        })
      }
    },
    collectLabels() {
      let frun = false
      if (!this.init) {
        let mg = {}
        let mc = {}
        this.layer.getSource().forEachFeature((f) => {
          mg[f.get('batch_name') || 'Default'] = true
          mc[f.get('qa_id')] = true
        })
        let dests = Object.keys(mg)
        this.tests = Object.keys(mc)
        this.selectedDests = [...dests]
        this.init = true
        frun = true

        let m = {}
        this.layer && this.layer.getSource().forEachFeature(f => {
          if (!m[f.get('id')]) {
            m[f.get('id')] = []
          }
          m[f.get('id')].push(f)
        })
        this.testMap = m
      }

      if (frun) {
        this.filterFeatures()
      }
    },
    filterFeatures(val, c) {
      if (c === 'qa_id') {
        if (this.selectedTests.indexOf(val) > -1) {
          this.selectedTests = this.selectedTests.filter(t => t !== val)
        } else {
          this.selectedTests.push(val)
        }
      }
      if (this.batch) {
        this.selectedDests = [this.batch]
      }
      let tests = this.selectedTests
      let dests = this.selectedDests

      this.reloadLayer(tests, dests)
    },
    reloadLayer(tests, dests) {
      if (!this.layerConf) {
        return
      }
      if (dests.length == 0 || tests.length == 0) {
        this.$mapService.map.removeLayer(this.layer)
        this.layer = null
        return
      }

      let cql = ' and id in (' + tests.map(c => "'" + c + "'").join(',') + ')'

      this.layerConf['cql_custom'] = this.layerConf['cql'] + cql
      this.$mapService.map.removeLayer(this.layer)
      this.layer = null
      this.findLayer(0)
    },
  },
  watch: {
    gasDest(val) {
      this.qaInfoDest = val
    },
    batch(val) {
      this.qaInfoDest = val
    },
    infoEnabled(val) {
      if (val !== localStorage.getItem('qa-info-unlocked')) {
        localStorage.setItem('qa-info-unlocked', val)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/map/QaTool.vue